<template>
    <div v-if="model">
        <v-row class="vertical-dense">
            <v-col cols="6">
                <v-text-field
                    label="Название"
                    v-model="model.name"
                    :error-messages="errorsFor('name')"
                />
            </v-col>
            <v-col cols="6">
                <v-select
                    label="Группа"
                    v-model="model.groupId"
                    :items="groupList"
                    item-value="id" item-text="name"
                    :error-messages="errorsFor('groupId')"
                />
            </v-col>

            <v-col cols="6">
                <v-select
                    label="Тип устройства"
                    v-model="model.type"
                    :items="typeList"
                    item-value="id" item-text="name"
                    :error-messages="errorsFor('type')"
                />
            </v-col>

            <v-col cols="6">
                <v-checkbox v-model="model.isHidden" label="Скрытое (отключенное)" />
            </v-col>

            <v-col cols="6">
                <v-select
                    label="Тип подключения"
                    v-model="model.linkType"
                    :items="linkTypeList"
                    item-value="id" item-text="name"
                    :error-messages="errorsFor('linkType')"
                />
            </v-col>

            <v-col cols="6">
                <v-text-field
                    label="Радиус действия (м)"
                    v-model="model.actionRadiusMeters"
                    :error-messages="errorsFor('actionRadiusMeters')"
                />
            </v-col>
        </v-row>

        <v-row class="vertical-dense">
            <v-col v-if="model.linkType && model.linkType !== 'no-link'">
                <v-text-field
                    label="Код устройства"
                    v-model="model.code"
                    :error-messages="errorsFor('code')"
                />
            </v-col>
            <v-col v-if="model.linkType && !['no-link', 'gs-sms'].includes(model.linkType)">
                <v-text-field
                    label="Тайм-аут связи (в секундах)"
                    v-model="model.timeout"
                    :error-messages="errorsFor('timeout')"
                />
            </v-col>
        </v-row>

        <div class="d-flex pt-3">
            <label>Положение</label>
            <v-btn
                v-if="storedCoords && (storedCoords[0] !== this.model.posY || storedCoords[1] !== this.model.posX)"
                x-small icon style="margin-left: 8px;" @click="restoreCoords"
                title="Восстановить положение"
            >
                <v-icon small>mdi-restore</v-icon>
            </v-btn>
        </div>
        <div class="d-flex scheme-field">
            <Scheme
                v-if="scene"
                :scene="scene"
                mode="picker"
                :picker-coords="[model.posY ?? 0, model.posX ?? 0]"
                @update:picker-coords="setCoords"
            />
        </div>
    </div>
</template>

<script lang="ts">
import {Component} from 'vue-property-decorator'
import {createDevice, DeviceDraft} from '@/models/Device'
import Scheme from '@/components/scheme/Scheme.vue'
import {Scene} from '@/types/Scene'
import {Coords} from '@/types/Coords'
import Form from '@/mixins/Form'

@Component({
    components: {Scheme},
})
export default class DeviceForm extends Form<DeviceDraft>
{
    storedCoords: Coords | null = null

    typeList: object[] = []
    linkTypeList: object[] = []
    groupList: object[] = []
    scene: Scene | null = null

    createModel(): DeviceDraft {
        return createDevice()
    }

    async created() {
        this.typeList = await this.api.listDeviceTypes()
        this.linkTypeList = await this.api.listDeviceLinkTypes()
        this.groupList = await this.api.listDeviceGroups({})
        await this.fetchScene()
    }

    valueChanged(value: DeviceDraft) {
        this.model = {...value}
        if (!this.storedCoords) {
            if (value.posY != null && value.posX != null) {
                this.storedCoords = [value.posY, value.posX]
            }
        }
    }

    async fetchScene() {
        this.scene = await this.api.getScene()
    }

    setCoords(coords: Coords) {
        if (this.model) {
            this.model.posY = coords[0]
            this.model.posX = coords[1]
        }
    }

    restoreCoords() {
        if (this.model && this.storedCoords) {
            this.model.posY = this.storedCoords[0]
            this.model.posX = this.storedCoords[1]
        }
    }
}
</script>
